import React from 'react'
import { Dropdown, Form } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const CountriesOfOriginEdit = ({ value = [], onChange, disabled = false }) => {
    const [t] = useTranslation()

    const options = (value || []).map(country => ({
        key: country,
        text: country,
        value: country,
    }))

    const handleChange = (_e, { value: newValue }) => {
        onChange(newValue)
    }

    return (
        <Form.Field>
            <label>{t('item_edit.countries_of_origin')}</label>
            <Dropdown
                fluid
                multiple
                search
                selection
                allowAdditions
                disabled={disabled}
                options={options}
                value={value || []}
                onChange={handleChange}
                additionLabel={`${t('global.add')} `}
                noResultsMessage={null}
            />
        </Form.Field>
    )
}

CountriesOfOriginEdit.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export { CountriesOfOriginEdit }

